import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Scale, Workflow, Landmark } from 'lucide-react';
import './Home.css';

const OPO_VISUALS = {
  auxilio: { Icon: Scale, color: '#6b3fa0', bg: '#f3eefb' },
  tramitación: { Icon: Workflow, color: '#2563eb', bg: '#eff6ff' },
  tramitacion: { Icon: Workflow, color: '#2563eb', bg: '#eff6ff' },
};
const DEFAULT_VISUAL = { Icon: Landmark, color: '#059669', bg: '#ecfdf5' };

const getOpoVisual = (name) => OPO_VISUALS[(name || '').toLowerCase()] || DEFAULT_VISUAL;

const Home = ({ user }) => {
  // `user` llega como prop desde App.js, que ya lo pidió a /users/me al
  // arrancar. Antes Home volvía a pedirlo aquí (una consulta a Neo4j
  // duplicada e idéntica en cada carga de la app, ya que PrivateRoute solo
  // renderiza Home cuando App ya tiene el usuario cargado).
  const [loading, setLoading] = useState(true);
  const [reviewQueue, setReviewQueue] = useState([]);

  useEffect(() => {
    const fetchReviewQueue = async () => {
      try {
        const rq = await axios.get('/api/me/review-queue?limit=20').catch(() => ({ data: [] }));
        setReviewQueue(rq.data || []);
      } catch (error) {
        console.error('Error fetching review queue', error);
      } finally {
        setLoading(false);
      }
    };
    fetchReviewQueue();
  }, []);

  if (loading) {
    return <div className="page-loader">Cargando…</div>;
  }

  const ops = (user && user.interested_oppositions) || [];
  const firstName = user && user.name ? user.name.split(' ')[0] : '';

  return (
    <div className="home-page">

      {firstName && (
        <p className="home-greeting">Hola, {firstName}</p>
      )}

      {reviewQueue.length > 0 && (
        <section className="home-section">
          <div className="card" style={{ background: '#fffaeb', border: '1px solid #f5e6b7', borderLeft: '4px solid #f0b400' }}>
            <h3 style={{ margin: '0 0 8px', color: '#8a6800' }}>📚 Tienes {reviewQueue.length} pregunta{reviewQueue.length === 1 ? '' : 's'} para repasar hoy</h3>
            <p style={{ margin: '0 0 12px', fontSize: 14, color: '#4a3500' }}>
              Repaso espaciado: refuerza lo que has fallado o lo que toca volver a ver.
            </p>
            <ol style={{ paddingLeft: 20, margin: 0, fontSize: 13, color: '#4a3500' }}>
              {reviewQueue.slice(0, 5).map((q, i, lista) => {
                // Las preguntas de un caso práctico no se entienden sin su enunciado: se muestra una vez por supuesto
                const claveSupuesto = (x) => (x.case_text ? `${x.exam}|${x.case_title}` : null);
                const primera = lista.findIndex((x) => claveSupuesto(x) === claveSupuesto(q)) === i;
                return (
                  <li key={i} style={{ marginBottom: 4 }}>
                    {q.case_text && (primera ? (
                      <details style={{ margin: '2px 0 4px' }}>
                        <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{q.case_title}: ver enunciado</summary>
                        <p style={{ margin: '6px 0', whiteSpace: 'pre-line', lineHeight: 1.5 }}>{q.case_text}</p>
                      </details>
                    ) : (
                      <div style={{ fontWeight: 600 }}>{q.case_title} (mismo enunciado que arriba)</div>
                    ))}
                    {q.text.length > 100 ? q.text.slice(0, 100) + '…' : q.text}
                    <span style={{ marginLeft: 8, fontSize: 11, opacity: 0.7 }}>caja {q.box}</span>
                  </li>
                );
              })}
            </ol>
          </div>
        </section>
      )}

      <section className="home-section">
        <h2 className="section-title">Tus oposiciones</h2>

        {ops.length === 0 ? (
          <div className="empty-state">
            <p>Aún no has elegido oposiciones que sigues.</p>
            <Link to="/profile" className="btn-primary">
              Configurar perfil →
            </Link>
          </div>
        ) : (
          <div className="opos-showcase">
            {ops.map((op) => {
              const { Icon, color, bg } = getOpoVisual(op);
              return (
                <Link to={`/oposicion/${op}`} key={op} className="opos-item">
                  <div className="opos-icon" style={{ background: bg, color }}>
                    <Icon size={40} strokeWidth={1.5} />
                  </div>
                  <span className="opos-name">{op}</span>
                  <span className="opos-cta">Ver oposición ›</span>
                </Link>
              );
            })}
          </div>
        )}
      </section>

    </div>
  );
};

export default Home;
